module.exports = __webpack_public_path__ + "media/img/vca/step3-72926297ae1d8d5b3eab1ffe7385aad4.png";